import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateStreamEntrypointMutation } from "../graphql/mutations";
import type {
  CreateStreamEntrypointMutationType,
  CreateStreamEntrypointMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateStreamEntrypointMutation = (
  options?: MutationHookOptions<
    CreateStreamEntrypointMutationType,
    CreateStreamEntrypointMutationVariablesType
  >
) => {
  return useMutation<
    CreateStreamEntrypointMutationType,
    CreateStreamEntrypointMutationVariablesType
  >(CreateStreamEntrypointMutation, options);
};
